export const WWDC_DATE_LABEL = 'June 8, 2026';
export const WWDC_TARGET_DATE = new Date(`${WWDC_DATE_LABEL} 00:00:00`).getTime();
export const WWDC_HERO_URL = 'https://developer.apple.com/wwdc26/images/p1-rtzhlm/wwdc26-sf-motion-still-last-large-p1_2x.jpg';

export type CountdownUnitLabel = 'Days' | 'Hours' | 'Minutes' | 'Seconds';

export type TimeRemaining = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export type CountdownSegment = {
  value: string;
  label: CountdownUnitLabel;
};

const padTimeValue = (value: number) => value.toString().padStart(2, '0');

export const getTimeRemaining = (targetTime: number, now = Date.now()): TimeRemaining => {
  const timeDifference = Math.max(targetTime - now, 0);

  return {
    days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
    hours: Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((timeDifference % (1000 * 60)) / 1000)
  };
};

export const getCountdownSegments = (timeRemaining: TimeRemaining): CountdownSegment[] => [
  { value: timeRemaining.days.toString(), label: 'Days' },
  { value: padTimeValue(timeRemaining.hours), label: 'Hours' },
  { value: padTimeValue(timeRemaining.minutes), label: 'Minutes' },
  { value: padTimeValue(timeRemaining.seconds), label: 'Seconds' }
];

export const getCountdownAriaLabel = ({ days, hours, minutes, seconds }: TimeRemaining) =>
  `${days} days ${hours} hours ${minutes} minutes ${seconds} seconds`;
